// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

export const INTAKE_V3_BASE_PATH = '/intake';

/** Fixed section labels for the step indicator, so nothing shifts as branches are added. */
export const INTAKE_V3_SECTIONS = ['Eligibility', 'Your details', 'Booking'] as const;

export interface IntakeV3Step {
  slug: string;
  title: string;
  /** Index into INTAKE_V3_SECTIONS. */
  section: number;
}

export const INTAKE_V3_STEPS: readonly IntakeV3Step[] = [
  { slug: 'eligibility', title: "Let's make sure we can see you", section: 0 },
  { slug: 'coverage', title: 'Insurance or self-pay', section: 0 },
  { slug: 'about-you', title: 'About you', section: 1 },
  { slug: 'where-you-live', title: "Where you live, and why you're here", section: 1 },
  { slug: 'pick-a-time', title: 'Pick a time', section: 2 },
  { slug: 'create-account', title: 'Create a password', section: 2 },
];

/** What IntakeV3Page passes each step's form. */
export interface IntakeV3StepProps {
  step: IntakeV3Step;
  /** Unset on the first step. */
  onBack?: () => void;
  onContinue: () => void;
}

/** Exits from the eligibility step for patients Polaris can't see yet. Not part of the step sequence. */
export const INTAKE_V3_WAITLISTS = {
  outOfArea: 'out-of-area',
  underAge: 'under-age',
} as const;

export type IntakeV3Waitlist = (typeof INTAKE_V3_WAITLISTS)[keyof typeof INTAKE_V3_WAITLISTS];

export function getIntakeV3StepPath(step: IntakeV3Step | IntakeV3Waitlist): string {
  return `${INTAKE_V3_BASE_PATH}/${typeof step === 'string' ? step : step.slug}`;
}

export const INTAKE_V3_ENTRY_PATH = getIntakeV3StepPath(INTAKE_V3_STEPS[0]);

export function isIntakeV3Path(pathname: string): boolean {
  return pathname === INTAKE_V3_BASE_PATH || pathname.startsWith(`${INTAKE_V3_BASE_PATH}/`);
}
